import {CampModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: CampModel = {
  id: '',
  nombre: '',
  siteId: '',
  clienteId: '',
  companiaId: '',
  ...aditionalValues,
}
